import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";
import { API, useAuth } from "../context/AuthContext";

export default function VerifyEmailBanner() {
  const { user } = useAuth();
  const [sent, setSent] = useState(false);
  if (!user || user.email_verified !== false) return null;
  const resend = async () => {
    try { await axios.post(`${API}/auth/resend-verification`); setSent(true); toast.success(`Email di conferma inviata a ${user.email}`); }
    catch (e) { toast.error(e.response?.data?.detail || "Invio non riuscito"); }
  };
  return (
    <div className="rl-card border-[#FF9F0A]/60 px-4 py-3 mb-6 flex flex-wrap items-center gap-3 text-sm" data-testid="verify-email-banner">
      <MailCheck className="w-5 h-5 text-[#FF9F0A]" />
      <div className="flex-1 min-w-[200px]"><b>Conferma la tua email</b> <span className="text-slate-400">({user.email}). Bonus invito e First Grid Bonus vengono accreditati solo dopo la conferma.</span></div>
      <button onClick={resend} disabled={sent} className="btn-outline-rl !py-2 !px-4 text-xs min-h-[44px]" data-testid="resend-verification-btn">{sent ? "INVIATA ✓" : "REINVIA EMAIL"}</button>
    </div>
  );
}
